export default __webpack_public_path__ + "static/media/promo-background.5b8e681b.png";